/**
 * Firebase-free value type representing a latitude/longitude pair stored in the
 * database. Replaces direct use of Firestore's `GeoPoint` in DTOs and models;
 * {@link BaseFirestoreService} maps it to/from a native `GeoPoint` at the
 * database boundary.
 */
export class JcGeoPoint {
    constructor(
        readonly latitude: number,
        readonly longitude: number
    ) { }
}
